/**
 * Order Service - API calls for orders
 */

import api from './api';

export const createOrder = (data) => api.post('/orders', data);

export const getMyOrders = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api.get(`/orders/my${query ? `?${query}` : ''}`);
};

export const getOrderById = (id) => api.get(`/orders/${id}`);

export const getOrderByNumber = (orderNumber) => 
  api.get(`/orders/number/${orderNumber}`);

// Admin order detail endpoints
export const getOrderDetail = (orderId) =>
  api.get(`/admin/orders/${orderId}/detail`);

export const checkOrderPayment = (orderId) =>
  api.get(`/admin/orders/${orderId}/payment-check`);

export const checkOrderDrCare = (orderId) =>
  api.get(`/admin/orders/${orderId}/drcare-check`);

export const updateOrderCosts = (orderId, costs) =>
  api.patch(`/admin/orders/${orderId}/costs`, costs);

// User order actions
export const submitSupportTicket = (orderId, message) =>
  api.post(`/orders/${orderId}/support-ticket`, { message });

export const submitCancelRequest = (orderId) =>
  api.post(`/orders/${orderId}/cancel-request`, {});

export const calculateRefill = (orderId) =>
  api.post(`/orders/${orderId}/refill/calculate`, {});

export const submitRefill = (orderId, data) =>
  api.post(`/orders/${orderId}/refill/submit`, data);


// Admin order management
export const updateTracking = (orderId, data) =>
  api.patch(`/admin/orders/${orderId}/tracking`, data);

export const updateInternalNotes = (orderId, internalNotes) =>
  api.patch(`/admin/orders/${orderId}/notes`, { internalNotes });

export const refundOrder = (orderId, amount) =>
  api.post(`/admin/orders/${orderId}/refund`, { amount });

export const voidOrderPayment = (orderId, transactionId) =>
  api.post(`/admin/orders/${orderId}/void`, { transactionId });

// Admin refill workflow
export const approveRefill = (orderId) =>
  api.post(`/admin/orders/${orderId}/refill/approve`, {});

export const denyRefill = (orderId) =>
  api.post(`/admin/orders/${orderId}/refill/deny`, {});

export default {
  createOrder,
  getMyOrders,
  getOrderById,
  getOrderByNumber,
  getOrderDetail,
  checkOrderPayment,
  checkOrderDrCare,
  updateOrderCosts,
  submitSupportTicket,
  submitCancelRequest,
  calculateRefill,
  submitRefill,
  updateTracking,
  updateInternalNotes,
  refundOrder,
  voidOrderPayment,
  approveRefill,
  denyRefill
};
